import React from 'react';

import { RevenueShareType } from 'src/api';
import { EmployerBillingRulesModalForm } from 'src/components/account';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { EmployerBillingRulesModalArgs } from './types';

export const EmployerBillingRulesChange: React.FC = () => {
  const { closeModal, switchClosability, isOpen, args } = useModal<EmployerBillingRulesModalArgs>(
    ModalId.EmployerBillingRulesChangeModal,
  );

  const handleCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Employer Billing Rules Change"
      maxWidth={400}
      dialogProps={{
        onClose: handleCloseModal,
        open: isOpen,
      }}
    >
      <EmployerBillingRulesModalForm
        billingRuleIds={args?.billingRuleIds}
        isAllSelected={args?.isAllSelected}
        revenueShare={args?.revenueShare}
        revenueShareType={args?.revenueShareType || RevenueShareType.Flat}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
